import { Grid, MenuItem, Select, Switch, TextField } from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { BsNature } from "../../../models/BsNature";
import { VendorTitle } from "../../../models/VendorTitle";
import { PaymentPurpose } from "../../../models/PaymentPurpose";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { RootState } from "../../../reducers";
import { useSelector } from "react-redux";
import AllActions from "../../../actions";
import { useEffect } from "react";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorDetailBasicMeta } from "../../../models/VendorDetail/VendorDetailBasicMeta";
import {
  FieldsLengthConstants,
  FileUploadTypes,
  NatureOfBusiness,
  RequestStatus,
} from "../../../constants/AppConstants";
import FileUpload from "../../../components/FileUpload/FileUpload";
import { UserLoginState } from "../../../reducers/LoginReducer";
import { Common } from "../../../utils/Common";

export default function PreparerInfo(props: any) {
  const classes = useStyles();
  const {
    getErrorState,
    handleChange,
    isEditableMode,
    handleOnBlur
  } = props;

  //const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  return (
    <div>
      <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.formOneWrapper} >
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_preparer_name_lbl}
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
            {(isEditableMode && vendorDetail.isVendorFillForm2 && Common.isVendor()) 
            && (<TextField
              variant="outlined"
              value={vendorDetail.FilledByName || ""}
              onChange={handleChange("FilledByName")}
              error={getErrorState("FilledByName")}
              inputProps={{ maxLength: FieldsLengthConstants.FilledByName }}
              onBlur={handleOnBlur("FilledByName")}
            />)}
            {!(isEditableMode && vendorDetail.isVendorFillForm2 && Common.isVendor())
            && (<span className={classes.textWrap}>
              {vendorDetail.FilledByName}
            </span>)}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_preparer_email_lbl}
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
            {(isEditableMode && vendorDetail.isVendorFillForm2 && Common.isVendor()) 
            && (<TextField
              variant="outlined"
              value={vendorDetail.FilledByEmail || ""}
              onChange={handleChange("FilledByEmail")}
              error={getErrorState("FilledByEmail")}
              inputProps={{ maxLength: FieldsLengthConstants.FilledByEmail }}
              onBlur={handleOnBlur("FilledByEmail")}
            />)}
            {!(isEditableMode && vendorDetail.isVendorFillForm2 && Common.isVendor()) 
            && (<span className={classes.textWrap}>
              {vendorDetail.FilledByEmail}
            </span>)}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_preparer_mobile_lbl}
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
          {/*   {(isEditableMode) 
            && (<TextField
              variant="outlined"
              value={vendorDetail.FilledByMobile || ""}
              onChange={handleChange("FilledByMobile")}
              error={getErrorState("FilledByMobile")}
              inputProps={{ maxLength: FieldsLengthConstants.FilledByMobile, inputMode: "numeric", pattern: "[0-9]*" }}              
              onBlur={handleOnBlur("FilledByMobile")}
            />)} */}
            
            {(isEditableMode) 
            && (<TextField
              variant="outlined"
              value={vendorDetail.FilledByMobile || ""}
              onChange={handleChange("FilledByMobile")}
              error={getErrorState("FilledByMobile")}
              helperText={
                getErrorState("FilledByMobile")
                  ? "Preparer Mobile Number format is invalid"
                  : ""
              }
              inputProps={{
                maxLength: 15,
                inputMode: "numeric",
                pattern: "[0-9]*"
              }}
              onBlur={handleOnBlur("FilledByMobile")}
            />)}

            {!(isEditableMode ) 
            && (<span className={classes.textWrap}>
              {vendorDetail.FilledByMobile}
            </span>)}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_preparer_designation_lbl}
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
            {(isEditableMode) 
            && (<TextField
              variant="outlined"
              value={vendorDetail.FilledByDesignation || ""}
              onChange={handleChange("FilledByDesignation")}
              error={getErrorState("FilledByDesignation")}
              inputProps={{ maxLength: FieldsLengthConstants.FilledByDesignation }}
              onBlur={handleOnBlur("FilledByDesignation")}
            />)}
            {!(isEditableMode) 
            && (<span className={classes.textWrap}>
              {vendorDetail.FilledByDesignation}
            </span>)}
          </Grid>
        </Grid>

      </Grid>
    </div>
  );
}
